const Loading: React.FC = () => <div></div>;

export default Loading;
